import React from 'react';
import styled from 'styled-components';
import RegisterAgencyForm from '../../components/agency/RegisterAgencyForm';
import tokLiveLogo from '../../assets/icons/ic_logo.png';

const RegisterAgencyPage = () => {
  return (
    <PageContainer>
      <Header>
        <LogoContainer>
          <img src={tokLiveLogo} alt="TokLive Logo" />
        </LogoContainer>
      </Header>
      <RegisterAgencyForm />
    </PageContainer>
  );
};

const PageContainer = styled.div`
  min-height: 100vh;
  background: #f5f7fb;
  padding: 2rem;
`;

const Header = styled.header`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
`;

const LogoContainer = styled.div`
  img {
    height: 50px;
    object-fit: contain;
  }
`;

export default RegisterAgencyPage;
